import styles from "./ReaderModal.module.css";

export type ReaderModalProps = { className?: string };

import { useI18n } from "@/contexts/i18nContext";
import Article from "@components/Article";
import Modal, { ModalContent, ModalDescription } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";
import Typography from "@components/Typography";

import { useMentionCard } from "../../../context";

const ReaderModal: React.FunctionComponent<ModalProps> = ({
  show,
  ...props
}) => {
  const {
    channel: { name },
    episode: { published_date, title, artwork_url },
    text_post,
  } = useMentionCard();
  const { formatDate } = useI18n();

  return (
    <Modal
      show={show}
      {...props}
      className={styles.modal}
      data-testid="reader-modal"
    >
      <ModalDescription>
        {name}, {formatDate(new Date(published_date), "PPPP")}
      </ModalDescription>
      <ModalContent>
        <Typography variant="h3">{title}</Typography>
        <div className={styles.wrapper}>
          {artwork_url && <img src={artwork_url} width="100%" />}
          {/** We know it's set here - Should be typed better to assure this higher up in the hierarchy */}
          <Article {...props} content={text_post?.text as string} />
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ReaderModal;
